var _rect, _g, _rect2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboradgrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 333,
    viewBox: "0 0 360 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1054_25607)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 333,
    fill: "#143A72"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1054_25607)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1054_25607",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -321,
    y: -162,
    width: 1040,
    height: 692
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_1054_25607_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.376812 -0.876393 0 199 137.369)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1043.4,
    height: 593.953,
    fill: "url(#paint0_diamond_1054_25607)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1043.4,
    height: 593.953,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_1054_25607)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1043.4,
    height: 593.953,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_1054_25607)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1043.4,
    height: 593.953,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_1054_25607)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -321,
    y: -162,
    width: 1040,
    height: 692,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.85098040103912354,\"g\":0.85098040103912354,\"b\":0.85098040103912354,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":-4.0530038635140653e-13,\"m01\":-1752.7867431640625,\"m02\":1075.3933105468750,\"m10\":753.62414550781250,\"m11\":1.6198652662280377e-12,\"m12\":-239.44302368164062},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1054_25607)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1054_25607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9102 -84.1699V778.817",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7969 -84.1699V778.817",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.684 -84.1699V778.817",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.571 -84.1699V778.817",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.458 -84.1699V778.817",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.345 -84.1699V778.817",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.231 -84.1699V778.817",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.118 -84.1699V778.817",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.005 -84.1699V778.817",
    stroke: "white",
    strokeWidth: 0.654481
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1054_25607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-315.184 41.4902L933 41.4902",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-315.184 83.377L933 83.377",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-315.184 125.264L933 125.264",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-315.184 167.15L933 167.15",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-315.184 209.037L933 209.037",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-315.184 250.924L933 250.924",
    stroke: "white",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-315.184 292.811L933 292.811",
    stroke: "white",
    strokeWidth: 0.654481
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_1054_25607_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -321,
    y: -162,
    width: 1040,
    height: 692
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_1054_25607",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1054_25607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 333,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1054_25607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376,
    height: 394,
    fill: "white",
    transform: "translate(-1 -7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1054_25607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1248.18,
    height: 806.841,
    fill: "white",
    transform: "translate(-315.184 -84.1699)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1054_25607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1248.18,
    height: 806.841,
    fill: "white",
    transform: "translate(-315.184 -84.1699)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboradgrid);
export default __webpack_public_path__ + "static/media/dashboradgrid.8229d2ddf3c19a7c0d7951726464c684.svg";
export { ForwardRef as ReactComponent };